import Layout from '../layout'
import {
    Box,
    Grid,
    Heading,
    Text,
    Button,
    Stack,
    Icon,
    Avatar,
} from "@chakra-ui/react";
import {
    FaStore,
    FaChartLine,
    FaShieldAlt,
    FaLeaf,
    FaRecycle,
    FaHeart,
    FaCheckCircle,
    FaHandshake,
    FaBolt,
    FaSeedling,
    FaBullseye,
    FaEye,
    FaWhatsapp
} from "react-icons/fa";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const Nosotros = () => {


    return (
        <Layout>
            <Box w={"full"} >

                {/* Hero Section */}
                <Box bg={"easycar1.500"} color="white" py={{ base: 20, lg: 28 }} textAlign="center" position="relative">
                    <Text
                        display="inline-block"
                        bg="rgba(52,145,65,0.2)"
                        color="green.300"
                        fontSize="xs"
                        fontWeight="semibold"
                        px={3}
                        py={1}
                        rounded="full"
                        textTransform="uppercase"
                        mb={4}
                        border="1px solid rgba(52,145,65,0.3)"
                    >
                        Conectando caminos, impulsando futuros
                    </Text>
                    <Heading fontWeight="extrabold" maxW="4xl" mx="auto" lineHeight="tight" fontSize={{ base: "4xl", sm: "5xl", lg: "6xl" }}>
                        Más que vehículos, somos el motor de tu movilidad..
                    </Heading>
                    <Text mt={6} fontSize={{ base: "lg", sm: "xl" }} maxW="2xl" mx="auto" color="whiteAlpha.800">
                        En EASYCAR transformamos la manera de adquirir un auto en El Salvador, ofreciendo confianza, respaldo y herramientas reales de crecimiento para emprendedores, empresas y hogares salvadoreños.
                    </Text>
                </Box>

                {/* ¿Quiénes Somos? */}
                <Box py={{ base: 16, lg: 24 }} bg="white">
                    <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={12} alignItems="center" maxW="7xl" mx="auto" px={{ base: 4, sm: 6, lg: 8 }}>
                        <Box>
                            <Heading fontSize="3xl" color="brand.blue" mb={6}>¿Quiénes Somos?</Heading>
                            <Text fontSize="lg" color="gray.600" mb={4}>
                                Con <strong>5 años de trayectoria en el mercado salvadoreño</strong> cumpliendo sueños vehiculares, en EASYCAR nos apasiona poner en marcha los proyectos de las personas y potenciar la productividad de los negocios. Somos una empresa líder en la comercialización de vehículos seminuevos y usados de alta calidad, <strong>inspeccionados</strong> para garantizar seguridad, durabilidad y el mejor valor del mercado.
                            </Text>
                            <Text fontSize="lg" color="gray.600" mb={4}>
                                Creemos firmemente que contar con un medio de transporte confiable no es un lujo, sino una herramienta indispensable de progreso. Por ello, combinamos un servicio cercano y procesos transparentes para que estrenar tu auto sea una experiencia ágil, segura y completamente confiable.
                            </Text>
                            <Box bg="green.50" borderLeft="4px solid #349141" p={4} rounded="md">
                                <Text fontWeight="semibold" color="brand.blue" fontSize="sm">
                                    Cobertura nacional: Contamos con agencias ubicadas estratégicamente en las zonas <strong>Occidente, Centro y Oriente</strong>
                                </Text>
                            </Box>
                        </Box>
                        <Box bg="brand.light" p={8} rounded="2xl" border="1px solid" borderColor="green.100" shadow="inner">
                            <Grid templateColumns="repeat(2,1fr)" gap={6} textAlign="center">
                                <Box bg="white" p={6} rounded="xl" shadow="sm">
                                    <Text fontSize="4xl" fontWeight="extrabold" color="#349141">5 Años</Text>
                                    <Text fontSize="sm" color="gray.500">En el mercado salvadoreño</Text>
                                </Box>
                                <Box bg="white" p={6} rounded="xl" shadow="sm">
                                    <Text fontSize="4xl" fontWeight="extrabold" color="#349141">+2,000</Text>
                                    <Text fontSize="sm" color="gray.500">Vehículos otorgados</Text>
                                </Box>
                                <Box bg="white" p={6} rounded="xl" shadow="sm" gridColumn="span 2">
                                    <Text fontSize="3xl" fontWeight="extrabold" color="brand.blue">Todo El Salvador</Text>
                                    <Text fontSize="sm" color="gray.500">Agencias en Occidente, Centro y Oriente</Text>
                                </Box>
                            </Grid>
                        </Box>
                    </Grid>
                </Box>

                {/* Misión y Visión */}
                <Box py={16} bg={"gray.200"}>
                    <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={8} maxW="7xl" mx="auto" px={{ base: 4, sm: 6, lg: 8 }}>
                        <Box bg="white" p={8} rounded="2xl" shadow="sm" border="1px solid" borderColor="gray.100">
                            <Avatar bg="green.100" color="#349141" size="lg" icon={<Icon as={FaBullseye} />} mb={6} />
                            <Heading fontSize="2xl" color="brand.blue" mb={4}>Nuestra Misión</Heading>
                            <Text color="gray.600" fontSize="lg">Brindar soluciones de movilidad confiables, accesibles y eficientes a través de la comercialización de vehículos usados certificados, garantizando una experiencia de compra excepcional y un servicio humano respaldado por un equipo comprometido con la excelencia en EASYCAR.</Text>
                        </Box>
                        <Box bg="white" p={8} rounded="2xl" shadow="sm" border="1px solid" borderColor="gray.100">
                            <Avatar bg="green.100" color="#349141" size="lg" icon={<Icon as={FaEye} />} mb={6} />
                            <Heading fontSize="2xl" color="brand.blue" mb={4}>Nuestra Visión</Heading>
                            <Text color="gray.600" fontSize="lg">Consolidarnos como la empresa referente en el mercado de vehículos usados en El Salvador y la región, reconocidos por nuestro impacto positivo en la economía local, el apoyo estratégico a los negocios y nuestro firme compromiso con la sostenibilidad y la economía circular en EASYCAR.</Text>
                        </Box>
                    </Grid>
                </Box>

                {/* Impacto Social y Apoyo a Negocios */}
                <Box py={{ base: 16, lg: 24 }} bg="white">
                    <Box textAlign="center" maxW="3xl" mx="auto" mb={16}>
                        <Text
                            display="inline-block"
                            bg="green.100"
                            color="#349141"
                            fontSize="xs"
                            fontWeight="semibold"
                            px={3}
                            py={1}
                            rounded="full"
                            textTransform="uppercase"
                            mb={3}
                        >
                            Progreso Compartido
                        </Text>
                        <Heading fontSize={{ base: "3xl", lg: "4xl" }} fontWeight="extrabold" color="brand.blue" mb={4}>
                            Impulsando el motor económico y comercial de El Salvador
                        </Heading>
                        <Text fontSize="lg" color="gray.600">
                            Otorgar un vehículo en óptimas condiciones va mucho más allá de un traslado personal; representa un catalizador de oportunidades para las familias y los negocios.
                        </Text>
                    </Box>
                    <Box maxW={"1400px"} margin={"auto"}>
                        <Grid templateColumns={{ base: "1fr", md: "repeat(3,1fr)" }} gap={8}>
                            <Box bg={"gray.200"} p={8} rounded="2xl" border="1px solid" borderColor="green.50">
                                <Icon as={FaStore} boxSize={12} color="white" bg="#349141" rounded="xl" p={3} mb={6} />
                                <Heading fontSize="xl" color="brand.blue" mb={3}>Aliados de Emprendedores y PyMEs</Heading>
                                <Text fontSize="sm" color="gray.600">Facilitamos la adquisición de vehículos comerciales o utilitarios que permiten a los negocios locales en EASYCAR expandir sus rutas de entrega, optimizar su logística y llegar a más clientes sin asfixiar su flujo de caja.</Text>
                            </Box>
                            <Box bg={"gray.200"} p={8} rounded="2xl" border="1px solid" borderColor="green.50">
                                <Icon as={FaChartLine} boxSize={12} color="white" bg="#349141" rounded="xl" p={3} mb={6} />
                                <Heading fontSize="xl" color="brand.blue" mb={3}>Autonomía y Productividad</Heading>
                                <Text fontSize="sm" color="gray.600">Proveemos transporte confiable que permite a profesionales independientes y equipos de trabajo trasladarse independientemente, reduciendo tiempos y multiplicando sus ingresos.</Text>
                            </Box>
                            <Box bg={"gray.200"} p={8} rounded="2xl" border="1px solid" borderColor="green.50">
                                <Icon as={FaShieldAlt} boxSize={12} color="white" bg="#349141" rounded="xl" p={3} mb={6} />
                                <Heading fontSize="xl" color="brand.blue" mb={3}>Inclusión y Seguridad Familiar</Heading>
                                <Text fontSize="sm" color="gray.600">Ofrecemos alternativas competitivas libres de la pesada depreciación de un auto nuevo, garantizando que cada viaje hacia el trabajo o el hogar se realice con total tranquilidad y respaldo en EASYCAR.</Text>
                            </Box>
                        </Grid>
                    </Box>
                </Box>

                {/* Economía Circular */}
                <Box py={20} bg="green.800" color="white" >
                    <Box mb={12} maxW={"1400px"} margin={"auto"}>
                        <Text
                            display="inline-block"
                            bg="green.700"
                            color="emerald.300"
                            fontSize="xs"
                            fontWeight="semibold"
                            px={3}
                            py={1}
                            rounded="full"
                            textTransform="uppercase"
                            mb={3}
                        >
                            Compromiso Sostenible
                        </Text>
                        <Heading fontSize={{ base: "3xl", lg: "4xl" }} fontWeight="extrabold" mb={4}>
                            Economía Circular: Dando una nueva vida a cada kilómetro
                        </Heading>
                        <Text fontSize="lg" color="emerald.100">
                            El sector automotriz tradicional genera una enorme huella ambiental debido a la fabricación masiva de unidades nuevas. En EASYCAR creemos firmemente que el desarrollo sostenible se construye optimizando lo que ya tenemos.
                        </Text>
                    </Box>
                    <Box maxW={"1400px"} margin={"auto"} mt={"4"}>
                        <Grid templateColumns={{ base: "1fr", md: "repeat(3,1fr)" }} gap={8}>
                            <Box bg={"green.900"} p={6} rounded="2xl" border="1px solid" borderColor="emerald.700">
                                <Heading fontSize="2xl" mb={3}><Icon as={FaLeaf} mr={2} /> Reducción Ambiental</Heading>
                                <Text fontSize="sm" color="emerald.100">Al extender el ciclo de vida útil de los vehículos mediante una rigurosa revisión y reacondicionamiento, disminuimos la demanda de recursos naturales asociados a la producción masiva.</Text>
                            </Box>
                            <Box bg={"green.900"} p={6} rounded="2xl" border="1px solid" borderColor="emerald.700">
                                <Heading fontSize="2xl" mb={3}><Icon as={FaRecycle} mr={2} /> Consumo Inteligente</Heading>
                                <Text fontSize="sm" color="emerald.100">Promovemos la reutilización eficiente de bienes duraderos de alta calidad, demostrando que un auto usado bien cuidado ofrece un rendimiento óptimo y frena el desperdicio industrial.</Text>
                            </Box>
                            <Box bg={"green.900"} p={6} rounded="2xl" border="1px solid" borderColor="emerald.700">
                                <Heading fontSize="2xl" mb={3}><Icon as={FaHeart} mr={2} /> Valor Sostenible</Heading>
                                <Text fontSize="sm" color="emerald.100">Cada vehículo que encuentra un nuevo hogar u optimiza una operación comercial forma parte de un modelo que cuida el planeta mientras dinamiza la economía local en EASYCAR.</Text>
                            </Box>
                        </Grid>
                    </Box>
                </Box>

                {/* Nuestros Valores */}
                <Box py={16} bg="white" textAlign="center">
                    <Heading fontSize="3xl" fontWeight="bold" color="brand.blue" mb={12}>Nuestros Valores</Heading>
                    <Box maxW={"1400px"} margin={"auto"}>
                        <Grid templateColumns={{ base: "1fr", sm: "repeat(2,1fr)", lg: "repeat(4,1fr)" }} gap={8}>
                            <Box p={6}>
                                <Icon as={FaCheckCircle} boxSize={10} color="#349141" mb={4} />
                                <Heading fontSize="lg" color="brand.blue" mb={2}>Transparencia</Heading>
                                <Text fontSize="sm" color="gray.500">Claridad absoluta en cada especificación vehicular...</Text>
                            </Box>
                            <Box p={6}>
                                <Icon as={FaHandshake} boxSize={10} color="#349141" mb={4} />
                                <Heading fontSize="lg" color="brand.blue" mb={2}>Compromiso</Heading>
                                <Text fontSize="sm" color="gray.500">Acompañamiento cercano antes, durante y después...</Text>
                            </Box>
                            <Box p={6}>
                                <Icon as={FaBolt} boxSize={10} color="#349141" mb={4} />
                                <Heading fontSize="lg" color="brand.blue" mb={2}>Innovación</Heading>
                                <Text fontSize="sm" color="gray.500">Uso de herramientas eficientes para agilizar gestiones...</Text>
                            </Box>
                            <Box p={6}>
                                <Icon as={FaSeedling} boxSize={10} color="#349141" mb={4} />
                                <Heading fontSize="lg" color="brand.blue" mb={2}>Sostenibilidad</Heading>
                                <Text fontSize="sm" color="gray.500">Prácticas orientadas a cuidar el entorno...</Text>
                            </Box>
                        </Grid>
                    </Box>
                </Box>

                {/* Call to Action */}
                <Box py={16} bg={"easycar1.500"} color="white" textAlign="center">
                    <Heading fontSize="3xl" mb={4}>¿Listo para llevar tu negocio o tu movilidad al siguiente nivel?</Heading>
                    <Text mb={8} maxW="xl" mx="auto" color="whiteAlpha.800">
                        Explora nuestro inventario actual o contacta a nuestros asesores en EASYCAR...
                    </Text>
                    <Stack direction={{ base: "column", sm: "row" }} justify="center" spacing={4}>
                        <Link to="/cars">
                            <Button bg="white" color="black" fontWeight="bold" px={8} py={3.5} rounded="xl" shadow="lg" >
                                Ver Inventario Disponible
                            </Button>
                        </Link>
                        <a
                            href={`https://wa.me/+50372900087?text=Me%20interesa%20adquirir%20el%20vehículo%20en%20arrendamiento%20financiero`}
                            target={"_blank"}
                            rel="noreferrer">
                        <Button bg={"easycar1.600"} color="white" fontWeight="semibold" px={8} py={3.5} rounded="xl" shadow="lg" leftIcon={<FaWhatsapp />} _hover={{ bg: "easycar1.700" }}>
                            Hablar con un Asesor
                        </Button>
                        </a>
                    </Stack>
                </Box>
            </Box>

        </Layout >
    )
}

export default Nosotros